<template>
    <div class="container-fluid form-container handover-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Job Sheet
                </h1>
            </div>
        </div>
        <invoice-form :form="form" />
        <form
            action=""
            class="handover-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                                @change="setArrivalTimeFromJob"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="customer_order_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <job-info
                v-if="form.job_id"
                :job-id="form.job_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Description</h3>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="fire_alarm"
                                name="fire_alarm"
                                v-model="form.fire_alarm"
                                class="form-check-input"
                            >
                            <label
                                for="fire_alarm"
                                class="form-check-label"
                            >Fire Alarm</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="annual_service"
                                name="annual_service"
                                v-model="form.annual_service"
                                class="form-check-input"
                            >
                            <label
                                for="annual_service"
                                class="form-check-label"
                            >Annual Service</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="scheduled_works"
                                name="scheduled_works"
                                v-model="form.scheduled_works"
                                class="form-check-input"
                            >
                            <label
                                for="scheduled_works"
                                class="form-check-label"
                            >Scheduled Works</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="emergency_lighting"
                                name="emergency_lighting"
                                v-model="form.emergency_lighting"
                                class="form-check-input"
                            >
                            <label
                                for="emergency_lighting"
                                class="form-check-label"
                            >Emergency Lighting</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="new_installation"
                                name="new_installation"
                                v-model="form.new_installation"
                                class="form-check-input"
                            >
                            <label
                                for="new_installation"
                                class="form-check-label"
                            >New Installation</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="call_out"
                                name="call_out"
                                v-model="form.call_out"
                                class="form-check-input"
                            >
                            <label
                                for="call_out"
                                class="form-check-label"
                            >Emergency Call Out</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="fire_ex"
                                name="fire_ex"
                                v-model="form.fire_ex"
                                class="form-check-input"
                            >
                            <label
                                for="fire_ex"
                                class="form-check-label"
                            >Fire Ex</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="additional_to_existing"
                                name="additional_to_existing"
                                v-model="form.additional_to_existing"
                                class="form-check-input"
                            >
                            <label
                                for="additional_to_existing"
                                class="form-check-label"
                            >Additional to Existing</label>
                        </div>

                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="handover"
                                name="handover"
                                v-model="form.handover"
                                class="form-check-input"
                            >
                            <label
                                for="handover"
                                class="form-check-label"
                            >Handover</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="security_alarm"
                                name="security_alarm"
                                v-model="form.security_alarm"
                                class="form-check-input"
                            >
                            <label
                                for="security_alarm"
                                class="form-check-label"
                            >Security Alarm</label>
                        </div>
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="remote_access"
                                name="remote_access"
                                v-model="form.remote_access"
                                class="form-check-input"
                            >
                            <label
                                for="remote_access"
                                class="form-check-label"
                            >Remote Access</label>
                        </div>
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="survey"
                                name="survey"
                                v-model="form.survey"
                                class="form-check-input"
                            >
                            <label
                                for="survey"
                                class="form-check-label"
                            >Survey</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="nurse_call"
                                name="nurse_call"
                                v-model="form.nurse_call"
                                class="form-check-input"
                            >
                            <label
                                for="nurse_call"
                                class="form-check-label"
                            >Nurse Call</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="access_control"
                                name="access_control"
                                v-model="form.access_control"
                                class="form-check-input"
                            >
                            <label
                                for="access_control"
                                class="form-check-label"
                            >Access Control</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="cctv"
                                name="cctv"
                                v-model="form.cctv"
                                class="form-check-input"
                            >
                            <label
                                for="cctv"
                                class="form-check-label"
                            >CCTV</label>
                        </div>
                    </div>

                    <div class="row form-group col-12">
                        <div class="form-check col-sm-6 col-md-4">
                            <input
                                type="checkbox"
                                id="risk_assessment"
                                name="risk_assessment"
                                v-model="form.risk_assessment"
                                class="form-check-input"
                            >
                            <label
                                for="risk_assessment"
                                class="form-check-label"
                            >Risk Assessment</label>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="job_description">Job Description</label>
                            <textarea
                                name="job_description"
                                id="job_description"
                                rows="5"
                                v-model="form.job_description"
                                placeholder="Job description..."
                                class="form-control"
                            />
                            <error
                                :errors="errors"
                                name="job_description"
                            />
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="form-group col-md-3 col-sm-6">
                            <label>Is Work Complete?</label>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="yes"
                                    v-model="form.work_complete"
                                    name="work_complete"
                                    id="work_complete_yes"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="work_complete_yes"
                                >Yes</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="no"
                                    v-model="form.work_complete"
                                    name="work_complete"
                                    id="work_complete_no"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="work_complete_no"
                                >No</label>
                            </div>
                        </div>

                        <div class="form-group col-md-3 col-sm-6">
                            <label>Log Book Updated?</label>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="yes"
                                    v-model="form.log_book_updated"
                                    name="log_book_updated"
                                    id="log_book_updated_yes"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="log_book_updated_yes"
                                >Yes</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="no"
                                    v-model="form.log_book_updated"
                                    name="log_book_updated"
                                    id="log_book_updated_no"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="log_book_updated_no"
                                >No</label>
                            </div>
                        </div>

                        <div class="form-group col-md-3 col-sm-6">
                            <label>Return Visit Needed?</label>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="yes"
                                    v-model="form.return_visit_needed"
                                    name="return_visit_needed"
                                    id="return_visit_needed_yes"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="return_visit_needed_yes"
                                >Yes</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="radio"
                                    value="no"
                                    v-model="form.return_visit_needed"
                                    name="return_visit_needed"
                                    id="return_visit_needed_no"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="return_visit_needed_no"
                                >No</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Materials</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label>Have any materials been used?</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <div class="form-check">
                                <input
                                    id="materials_used_no"
                                    name="materials_used"
                                    type="checkbox"
                                    v-model="form.materials_used"
                                    :required="materials.length < 1"
                                    true-value="No"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label"
                                    for="materials_used_no"
                                >No</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    name="materials_used"
                                    v-model="form.materials_used"
                                    :required="materials.length > 0"
                                    true-value="Yes"
                                    class="form-check-input"
                                >
                                <label class="form-check-label">
                                    Yes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        class="row"
                        v-if="form.materials_used !== 'No'"
                    >
                        <div class="col-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th
                                            @click.prevent="sortMaterials('qty')"
                                            :class="sortClass('qty')"
                                        >
                                            Qty
                                        </th>
                                        <th
                                            @click.prevent="sortMaterials('material')"
                                            :class="sortClass('material')"
                                        >
                                            Materials Used
                                        </th>
                                        <th
                                            @click.prevent="sortMaterials('part_no')"
                                            :class="sortClass('part_no')"
                                        >
                                            Part No.
                                        </th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, i) in materials"
                                        :key="i"
                                    >
                                        <td>
                                            <input
                                                type="number"
                                                step="1"
                                                name="qty[]"
                                                class="form-control"
                                                v-model="row.qty"
                                                required
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="material[]"
                                                class="form-control"
                                                v-model="row.material"
                                                required
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="part_no[]"
                                                class="form-control"
                                                v-model="row.part_no"
                                            >
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                class="btn btn-outline-danger btn-small"
                                                @click="removeMaterial(i)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <button
                                type="button"
                                class="btn btn-outline-info btn-small"
                                @click="addMaterial()"
                            >
                                <i class="fa fa-plus" /> Add Material
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Notes and Time</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="job_notes">Job Notes</label>
                            <textarea
                                name="job_notes"
                                id="job_notes"
                                rows="5"
                                v-model="form.job_notes"
                                placeholder="Job notes..."
                                class="form-control"
                            />
                            <error
                                name="job_notes"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="travel_time">Travel Time</label>
                            <input
                                type="text"
                                v-model="form.travel_time"
                                id="travel_time"
                                name="travel_time"
                                placeholder="Travel Time"
                                class="form-control"
                            >
                            <error
                                name="travel_time"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="arrival_time">Arrival Time</label>
                            <input
                                type="text"
                                v-model="form.arrival_time"
                                id="arrival_time"
                                name="arrival_time"
                                placeholder="DD/MM/YYYY HH:MM"
                                class="form-control"
                            >
                            <error
                                name="arrival_time"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="departure_time">Depature Time</label>
                            <input
                                type="text"
                                v-model="form.departure_time"
                                id="departure_time"
                                name="departure_time"
                                placeholder="DD/MM/YYYY HH:MM"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="departure_time"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="total_time">Total Time</label>
                            <input
                                type="text"
                                v-model="form.total_time"
                                id="total_time"
                                name="total_time"
                                placeholder="Total Time"
                                class="form-control"
                            >
                            <error
                                name="total_time"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="total_time">No. Engineers Attended</label>
                            <input
                                type="number"
                                v-model="form.no_engineers_attended"
                                id="no_engineers_attended"
                                name="no_engineers_attended"
                                placeholder="No. Engineers Attended"
                                class="form-control"
                                min="1"
                                max="20"
                                required
                            >
                            <error
                                name="total_time"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4 form-group">
                            <label for="total_time">Parking Fee</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">£</span>
                                </div>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    v-model="form.parking_fee"
                                    class="form-control"
                                >
                            </div>
                            <error
                                name="parking_fee"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <form-photos :form-id="form.id" />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>{{ `Photo for ${companyName}` }}</h3>
                        </div>
                    </div>
                    <div class="attachments">
                        <fire-alarm-upload-preview
                            :upload="form.internal_photo"
                            v-if="form.internal_photo"
                            @change="oldInternalPhotoChanged"
                        />
                        <fire-alarm-upload-preview
                            v-for="(photo, i) in form.internal_photos"
                            :key="i"
                            :upload="photo"
                            @change="(newUrl) => internalPhotoChanged(i, newUrl)"
                        />
                        <label
                            class="attachments-btn btn btn-primary"
                        >
                            Choose file
                            <input
                                type="file"
                                @change="uploadInternalPhoto($event)"
                                accept="image/*,application/pdf"
                                class="block"
                                multiple
                            >
                        </label>
                    </div>
                </div>
            </div>


            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit'"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import SignatureComponent from "../SignatureComponent.vue";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import UsersService from "../../services/UsersService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import Sortables from "../../mixins/Sortables";
import JobInfo from "./parts/JobInfoComponent";
import InvoiceForm from "./parts/InvoiceFormComponent";
import FormPhotos from "./parts/FormPhotosComponent.vue";
import FireAlarmUploadPreview from "./parts/FireAlarmUploadPreview.vue";
import UploadService from "../../services/UploadService";

export default {
    components: {
        FireAlarmUploadPreview,
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
        signature: SignatureComponent,
        JobInfo,
        InvoiceForm,
        FormPhotos,
    },
    mixins: [UsesErrors, UsesInfoMessage, Sortables, UsesFormRouteQuery],
    props: {
        formId: {
            default: () => null,
        },
    },
    data: function () {
        return {
            officeStaff: [],
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {
                type: "handover",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: '',
                materials: [],
                engineer_sign_date: moment(),
                customer_sign_date: moment(),
            },
            materials: [],
            token: null,
            companyName: window.SystemSettings.company_name,
        };
    },
    computed: {
        canDelete: function () {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        },
    },
    mounted: function () {
        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then((res) => {
                this.form.doc_no = res.data;
            });
        }

        this.getOfficeStaff();
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id)
                .then(
                    (res) => {
                        this.form = res.data;
                        this.materials = this.form.materials
                            ? this.form.materials
                            : [];
                        if (res.data.engineer_sign_date) {
                            this.form.engineer_sign_date = moment(
                                res.data.engineer_sign_date
                            );
                        } else {
                            this.form.engineer_sign_date = moment();
                        }
                        if (res.data.customer_sign_date) {
                            this.form.customer_sign_date = moment(
                                res.data.customer_sign_date
                            );
                        } else {
                            this.form.customer_sign_date = moment();
                        }
                        this.getJobs();
                        this.setArrivalTimeFromJob();
                    },
                    (err) => {
                        this.setErrorMessage("Could not load form");
                        console.error(err);
                    }
                )
                .then(() => {
                    this.clearLoading();
                });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
            this.getJobs();
        },
        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                (err) => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },
        saveForm: function () {
            this.setSaving();
            this.clearErrors();
            if (
                this.$refs.customerSignature &&
                !this.$refs.customerSignature.isEmpty()
            ) {
                this.form.customer_signature =
                    this.$refs.customerSignature.toPng();
            }
            this.form.materials = this.materials;
            if (
                this.form.materials_used !== "No" &&
                this.form.materials.length < 1
            ) {
                this.showErrorMessage(
                    "Please check that materials used have been recorded"
                );
                return;
            }
            let data = {...this.form};
            delete data["customer"];
            delete data["site"];
            delete data["job"];
            delete data["data"];

            if (this.form.id) {
                Service.update(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit("formSaved", res.data);
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes("engineer/")) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        }
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    (xhr) => {
                        this.setInfoMessage("Form successfully deleted");
                        // TODO: Redirect to relavant page
                        this.$router.push({name: "office.forms.search"});
                    },
                    (error) => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },
        addMaterial: function () {
            this.materials.push({
                qty: 1,
                material: "",
                part_no: "",
            });
        },
        removeMaterial: function (i) {
            const confirm = window.confirm(
                "Are you sure you want to delete this item?"
            );
            if (!confirm) {
                return;
            }
            this.materials.splice(i, 1);
        },

        getOfficeStaff: function () {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    (xhr) => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },

        sortMaterials(key) {
            this.materials = this.sortItems(key, this.materials);
            this.$forceUpdate();
        },

        onJobLoadedFromRoute() {
            this.getJobs();
            this.setArrivalTimeFromJob();
        },

        setArrivalTimeFromJob() {
            if (!this.form.job_id || this.form.arrival_time) {
                return;
            }
            JobService.get(this.form.job_id).then((res) => {
                this.form.arrival_time = res.data.attended_at
                    ? window
                        .moment(res.data.attended_at)
                        .format("DD/MM/YY HH:mm")
                    : "";
                this.$forceUpdate();
            });
        },

        oldInternalPhotoChanged(newUrl) {
            this.form.internal_photo = newUrl;
            this.$forceUpdate();
        },

        internalPhotoChanged(index, newUrl) {
            if (!newUrl) {
                this.form.internal_photos.splice(index, 1);
            } else {
                this.form.internal_photos[index] = `${newUrl}?time=${Date.now()}`;
            }
            this.$forceUpdate();
        },

        uploadInternalPhoto(event) {
            this.form.internal_photos = this.form.internal_photos || [];
            if (!event.target.files[0]) {
                return;
            }
            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                UploadService.upload(file, 1024)
                    .then((res) => {
                        this.form.internal_photos.push(res.data.full_url);
                        this.$forceUpdate();
                    })
                    .catch((err) => {
                        this.setErrorMessage(
                            "Failed to upload file, please try again"
                        );
                        console.error(err);
                        window.setTimeout(() => {
                            this.setErrorMessage(null);
                        }, 5000);
                    });
            }
        }
    },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/HandoverFormComponent.vue